import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../SEOHead';
import { Twitter, Facebook, Instagram, CloudRain, Music, Youtube, Mail } from 'lucide-react';

const HomePage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    "name": "Exlo",
    "genre": ["Electronic", "AI-Assisted Music", "Digital Music"],
    "description": "Exlo creates emotional electronic music using AI assistance. Listen to Ghost In Plain Sight, Venomous Crusade, From The Inside, Masked Reality, Autumn's Embrace, Screen-Lit Youth, and OK Boomer.",
    "url": "https://music.exlo.no",
    "image": "/artist_photo.png",
    "sameAs": [
      "https://x.com/TeAmExlo",
      "https://www.facebook.com/exlo84",
      "https://www.instagram.com/exlo_84/",
      "https://open.spotify.com/artist/0LLP1veWAmGmNZ3mxAZvPF",
      "https://www.youtube.com/@ExloMusicNO",
      "https://soundcloud.com/exlo-exlo-177213603"
    ],
    "member": {
      "@type": "Person",
      "name": "Exlo",
      "jobTitle": "AI-Assisted Music Producer",
      "description": "Tech-savvy wordsmith creating emotional electronic music with AI assistance."
    },
    "album": [
      {
        "@type": "MusicAlbum",
        "name": "Latest Releases",
        "url": "https://music.exlo.no/releases",
        "track": [
          {
            "@type": "MusicRecording",
            "name": "Ghost In Plain Sight",
            "url": "https://open.spotify.com/track/0rt1nQOw34V0SXRAw5oOuD",
            "description": "A song about internal battles and hidden struggles, offering hope and resilience."
          },
          {
            "@type": "MusicRecording",
            "name": "From The Inside",
            "url": "https://open.spotify.com/track/4Fujv6FSCx3EzSLyYO3zlz",
            "description": "A journey through internal struggle towards healing and self-discovery."
          },
          {
            "@type": "MusicRecording",
            "name": "Venomous Crusade",
            "url": "https://open.spotify.com/track/4E83tT4l2rlPLID47YpwVy",
            "description": "A tale of betrayal, loss, and the unwavering love of a father."
          },
          {
            "@type": "MusicRecording",
            "name": "Masked Reality",
            "url": "https://open.spotify.com/track/15TLRRojTlqRKI3aT8MV0b",
            "description": "Commentary on deception in music and life, celebrating the artistry of wordplay."
          },
          {
            "@type": "MusicRecording",
            "name": "Autumn's Embrace",
            "url": "https://open.spotify.com/track/6ydc7efV09laNTLfuzVDPb",
            "description": "Exploration of nocturnal anxiety and depression with a message of resilience."
          },
          {
            "@type": "MusicRecording",
            "name": "Screen-Lit Youth",
            "url": "https://open.spotify.com/track/2H2FKAtMcmfufnWgeYMg02",
            "description": "Critical examination of modern youth culture and digital dependence."
          },
          {
            "@type": "MusicRecording",
            "name": "OK Boomer (Screen-Lit Youth Response)",
            "url": "https://open.spotify.com/track/6cExbnvow5Vsw8M5Wg3atS",
            "description": "Youth perspective counter-narrative defending digital native culture."
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white font-sans">
      <SEOHead
        title="Exlo - AI-Assisted Electronic Music | Human Heart, Digital Sound"
        description="Exlo creates emotional electronic music using AI assistance. Listen to Ghost In Plain Sight, Venomous Crusade, From The Inside, Masked Reality, Autumn's Embrace, Screen-Lit Youth, and OK Boomer."
        url="/"
        structuredData={structuredData}
      />
      
      <noscript>
        <div className="p-8 text-center">
          <h1 className="text-3xl font-bold mb-4 text-[#e94560]">Exlo Music</h1>
          <h2 className="text-xl mb-4 text-cyan-400">Human heart, digital sound: The future of music has been found.</h2>
          <p className="text-lg mb-6">AI-assisted electronic music with emotional depth.</p>
          <div className="mb-6">
            <h3 className="text-xl font-bold mb-2 text-[#e94560]">Latest Releases</h3>
            <ul className="list-disc list-inside space-y-2">
              <li><a href="https://open.spotify.com/track/0rt1nQOw34V0SXRAw5oOuD" className="text-cyan-400 underline">Ghost In Plain Sight</a></li>
              <li><a href="https://open.spotify.com/track/4Fujv6FSCx3EzSLyYO3zlz" className="text-cyan-400 underline">From The Inside</a></li>
              <li><a href="https://open.spotify.com/track/4E83tT4l2rlPLID47YpwVy" className="text-cyan-400 underline">Venomous Crusade</a></li>
              <li><a href="https://open.spotify.com/track/15TLRRojTlqRKI3aT8MV0b" className="text-cyan-400 underline">Masked Reality</a></li>
              <li><a href="https://open.spotify.com/track/6ydc7efV09laNTLfuzVDPb" className="text-cyan-400 underline">Autumn's Embrace</a></li>
              <li><a href="https://open.spotify.com/track/2H2FKAtMcmfufnWgeYMg02" className="text-cyan-400 underline">Screen-Lit Youth</a></li>
              <li><a href="https://open.spotify.com/track/6cExbnvow5Vsw8M5Wg3atS" className="text-cyan-400 underline">OK Boomer</a></li>
            </ul>
          </div>
          <div className="mb-6">
            <h3 className="text-xl font-bold mb-2 text-[#e94560]">Connect</h3>
            <ul className="list-disc list-inside space-y-2">
              <li><a href="https://open.spotify.com/artist/0LLP1veWAmGmNZ3mxAZvPF" className="text-cyan-400 underline">Spotify</a></li>
              <li><a href="https://www.youtube.com/@ExloMusicNO" className="text-cyan-400 underline">YouTube</a></li>
              <li><a href="https://x.com/TeAmExlo" className="text-cyan-400 underline">Twitter</a></li>
            </ul>
          </div>
        </div>
      </noscript>

      <header className="h-[200px] relative overflow-hidden flex items-center bg-[#16213e]">
        <div className="container mx-auto px-8 md:px-16 flex justify-between items-center">
          <div className="max-w-[50%]">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-2 text-cyan-400">Human heart, digital sound:</h1>
            <p className="text-base md:text-lg lg:text-xl text-cyan-400 mb-4">The future of music has been found.</p>
            <a 
              href="https://open.spotify.com/artist/0LLP1veWAmGmNZ3mxAZvPF" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-[#e94560] text-white font-bold py-2 px-4 rounded inline-block text-sm md:text-base hover:bg-[#d73650] transition-colors"
            >
              Listen Now
            </a>
          </div>
          <div className="w-[200px] h-[200px] overflow-hidden">
            <img
              src={`${process.env.PUBLIC_URL}/exlo-logo.png`}
              alt="Exlo - AI-Assisted Electronic Music Artist"
              className="w-full h-full object-cover"
              width={200}
              height={200}
              loading="eager"
              onError={(e) => {
                console.error('Image failed to load:', e.target.src);
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
              onLoad={() => console.log('Image loaded successfully')}
            />
            <div className="w-full h-full items-center justify-center text-center text-cyan-400 hidden">
              <div>
                <div className="text-4xl mb-2">🎵</div>
                <div className="text-sm">Exlo</div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="p-4 md:p-8 max-w-6xl mx-auto">
        <section className="mb-12">
          <h2 className="text-3xl font-bold mb-6 text-[#e94560]">Welcome to Exlo Music</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-transparent border border-[#e94560] rounded-lg p-6 hover:border-cyan-400 transition-colors">
              <h3 className="text-xl font-bold mb-4 text-[#e94560]">Latest Releases</h3>
              <p className="text-gray-300 mb-4">Stream the newest electronic tracks on Spotify, featuring emotional depth and AI-assisted production.</p>
              <Link to="/releases" className="text-cyan-400 underline hover:text-cyan-300 transition-colors">
                Explore Releases →
              </Link>
            </div>
            
            <div className="bg-transparent border border-[#e94560] rounded-lg p-6 hover:border-cyan-400 transition-colors">
              <h3 className="text-xl font-bold mb-4 text-[#e94560]">Music Videos</h3>
              <p className="text-gray-300 mb-4">Watch the latest music videos on YouTube, bringing electronic soundscapes to life with compelling visuals.</p>
              <Link to="/videos" className="text-cyan-400 underline hover:text-cyan-300 transition-colors">
                Watch Videos →
              </Link>
            </div>
            
            <div className="bg-transparent border border-[#e94560] rounded-lg p-6 hover:border-cyan-400 transition-colors">
              <h3 className="text-xl font-bold mb-4 text-[#e94560]">Song Stories</h3>
              <p className="text-gray-300 mb-4">Discover the deep meanings behind each track, exploring themes of resilience, hope, and human emotion.</p>
              <Link to="/about-songs" className="text-cyan-400 underline hover:text-cyan-300 transition-colors">
                Read Stories →
              </Link>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-3xl font-bold mb-6 text-[#e94560]">Connect With Exlo</h2>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="https://x.com/TeAmExlo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-[#0f3460] text-white py-2 px-4 rounded flex items-center gap-2 hover:bg-[#1a4a7a] transition-colors"
              aria-label="Follow Exlo on Twitter"
            >
              <Twitter size={20} /> Twitter
            </a>
            <a 
              href="https://www.facebook.com/exlo84" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-[#0f3460] text-white py-2 px-4 rounded flex items-center gap-2 hover:bg-[#1a4a7a] transition-colors"
              aria-label="Follow Exlo on Facebook"
            >
              <Facebook size={20} /> Facebook
            </a>
            <a 
              href="https://www.instagram.com/exlo_84/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-[#0f3460] text-white py-2 px-4 rounded flex items-center gap-2 hover:bg-[#1a4a7a] transition-colors"
              aria-label="Follow Exlo on Instagram"
            >
              <Instagram size={20} /> Instagram
            </a>
            <a 
              href="https://soundcloud.com/exlo-exlo-177213603" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-[#0f3460] text-white py-2 px-4 rounded flex items-center gap-2 hover:bg-[#1a4a7a] transition-colors"
              aria-label="Listen to Exlo on SoundCloud"
            >
              <CloudRain size={20} /> Soundcloud
            </a>
            <a 
              href="https://open.spotify.com/artist/0LLP1veWAmGmNZ3mxAZvPF" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-[#0f3460] text-white py-2 px-4 rounded flex items-center gap-2 hover:bg-[#1a4a7a] transition-colors"
              aria-label="Listen to Exlo on Spotify"
            >
              <Music size={20} /> Spotify
            </a>
            <a 
              href="https://www.youtube.com/@ExloMusicNO" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-[#0f3460] text-white py-2 px-4 rounded flex items-center gap-2 hover:bg-[#1a4a7a] transition-colors"
              aria-label="Watch Exlo on YouTube"
            >
              <Youtube size={20} /> YouTube
            </a>
            <a 
              href="mailto:music@exlo.no" 
              className="bg-[#0f3460] text-white py-2 px-4 rounded flex items-center gap-2 hover:bg-[#1a4a7a] transition-colors"
              aria-label="Email Exlo"
            >
              <Mail size={20} /> E-Mail
            </a>
          </div>
        </section>
      </main>

      <footer className="bg-[#16213e] text-white p-4 text-center">
        <p>© Exlo 2025. All rights reserved.</p>
        <nav className="mt-2">
          <Link to="/releases" className="text-cyan-400 hover:text-cyan-300 mx-2">Releases</Link>
          <Link to="/videos" className="text-cyan-400 hover:text-cyan-300 mx-2">Videos</Link>
          <Link to="/about-songs" className="text-cyan-400 hover:text-cyan-300 mx-2">Song Stories</Link>
          <Link to="/about-me" className="text-cyan-400 hover:text-cyan-300 mx-2">About</Link>
          <Link to="/media" className="text-cyan-400 hover:text-cyan-300 mx-2">Media</Link>
        </nav>
      </footer>
    </div>
  );
};

export default HomePage;
